import React, { useState, useEffect } from "react";
import Layout from "../../components/layouts/layout";
import BannerBgImage from "../../assets/Images/services/consult-banner.png";
import TwoColumnContactInfo from "../../templates/TwoColumnContactInfo";
import Clm1Img from "../../assets/Icons/phone.svg";
import Clm2Img from "../../assets/Icons/mail.svg";
import BannerSection from "../../components/servicesSection/banner";
import OurOffering from "../../components/servicesSection/ourOffering";
import CtaCardSection from "../../components/CTASection/ctaCard2";
import CTAIMAGE1 from "../../assets/Images/Clutch/Cta/phone-contact.png";
import FullStackExpertise from "../../components/FullStackExpertise";
import ConsultImage from "../../assets/Images/Homepage/FullStackExpertise/build.png";
import OurModelSection from "../../components/OurModelSection";
import SkeletonOfferingLoader from "../../components/SkeletonOfferingCard";
import FAQSection from "../../components/NewHomePage/FAQSection";

const buildFaqs = [
  {
    q: "What does DigiRyte's Build service include?",
    a:
      "DigiRyte's Build service covers end-to-end software development, including product design, architecture planning, development, testing, deployment, and ongoing support. The focus is on delivering scalable, high-performance digital solutions aligned with business goals.",
  },
  {
    q: "What types of digital products can DigiRyte build for businesses?",
    a:
      "DigiRyte builds a wide range of digital products, including web applications, mobile apps, SaaS platforms, enterprise systems, APIs, and data-driven solutions. Each product is tailored to meet specific business requirements.",
  },
  {
    q: "Do you offer custom software development as part of the Build service?",
    a:
      "Yes, custom software development is a core part of DigiRyte's Build service. Solutions are designed and developed from the ground up to match unique business needs, ensuring flexibility, scalability, and long-term value.",
  },
  {
    q: "Can DigiRyte build AI-powered applications and platforms?",
    a:
      "Absolutely. DigiRyte develops AI-powered solutions using technologies such as machine learning, natural language processing, and predictive analytics to enhance automation, decision-making, and user experience.",
  },
  {
    q: "Do you develop both web and mobile applications?",
    a:
      "Yes, DigiRyte develops both web and mobile applications, including responsive web platforms, native mobile apps, and cross-platform solutions to ensure seamless user experiences across devices.",
  },
  {
    q:
      "How does DigiRyte turn consulting insights into scalable software solutions?",
    a:
      "DigiRyte translates consulting insights into actionable development plans by defining clear architectures, selecting the right technologies, and implementing best practices. This ensures that the final product is scalable, efficient, and aligned with strategic goals.",
  },
  {
    q: "What technologies and frameworks do you use for software development?",
    a:
      "DigiRyte uses modern, industry-standard technologies and frameworks across frontend, backend, cloud, and AI. The tech stack is chosen based on project requirements to ensure performance, scalability, and maintainability.",
  },
  {
    q:
      "How do you ensure software scalability and performance during development?",
    a:
      "Scalability and performance are built into the development process through robust architecture design, efficient coding practices, cloud-native infrastructure, and continuous performance testing.",
  },
  {
    q: "Can DigiRyte build SaaS platforms for startups and enterprises?",
    a:
      "Yes, DigiRyte specialises in building scalable SaaS platforms tailored for both startups and enterprises, with features such as multi-tenancy, subscription management, and cloud scalability.",
  },
  {
    q: "How long does it take to build a custom digital product?",
    a:
      "The timeline depends on the complexity and scope of the project. MVPs may take a few weeks to a few months, while full-scale platforms can take several months for complete development and deployment.",
  },
  {
    q: "What development methodology does DigiRyte use for product delivery?",
    a:
      "DigiRyte follows agile development methodologies, enabling iterative progress, continuous feedback, and flexibility to adapt to changing business requirements.",
  },
  {
    q: "Do you provide cloud-native application development?",
    a:
      "Yes, DigiRyte develops cloud-native applications designed for scalability, resilience, and performance, leveraging modern cloud platforms and architectures.",
  },
  {
    q: "Can DigiRyte modernise or rebuild existing software systems?",
    a:
      "Yes, DigiRyte helps modernise legacy systems by upgrading technologies, improving architecture, and rebuilding applications where necessary to meet current and future business needs.",
  },
  {
    q: "How does DigiRyte ensure security and reliability in the build phase?",
    a:
      "Security and reliability are ensured through best practices such as secure coding standards, regular testing, performance monitoring, and robust infrastructure design to minimise risks and ensure system stability.",
  },
  {
    q: "What is the typical process when working with DigiRyte's Build team?",
    a:
      "The process typically includes discovery and planning, design and architecture, development, testing, deployment, and ongoing support. Throughout the process, DigiRyte maintains transparency, collaboration, and a focus on delivering measurable outcomes.",
  },
];

function BuildScreen() {
  // Import Sanity service inside component to avoid build-time issues
  const { SanityService } = require("../../services/sanity");

  // State for dynamic offerings
  const [offerList, setOfferList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch offerings from Sanity on component mount
  useEffect(() => {
    const fetchOfferings = async () => {
      try {
        setLoading(true);
        setError(null);
        const sanityOfferings = await SanityService.getOfferingsByPageType(
          "build",
        );
        console.log(sanityOfferings, "sanityOfferings");

        setOfferList(sanityOfferings || []);
      } catch (error) {
        console.error("Error fetching offerings:", error);
        setError("Failed to load offerings. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchOfferings();
  }, []);

  const TwoColumnContactInfoData = {
    Clm1Img: Clm1Img,
    Clm1Title: "Phone:",
    Clm1SubTitle: "+44 (0) 161 706 7983",
    Clm2Img: Clm2Img,
    Clm2Title: "Email:",
    Clm2SubTitle: "hello@digiryte.com",
  };

  return (
    <Layout
      seo={{
        title: "Service - Build | DigiRyte",
        ogtitle: "Service - Build | DigiRyte",
        description: "Build",
        keywords:
          "software development, application development, MVP development, web development, mobile development, product development",
      }}
    >
      <BannerSection
        bannerImage={BannerBgImage}
        title="Build"
        subtitle={<>Agile Digital Delivery</>}
        image={ConsultImage}
      />

      <div className="mt-40">
        <div className="body-container">
          {loading ? (
            <SkeletonOfferingLoader count={6} />
          ) : error ? (
            <div
              style={{
                textAlign: "center",
                padding: "100px 20px",
                minHeight: "400px",
              }}
            >
              <p
                style={{
                  fontSize: "18px",
                  color: "#D32F2F",
                  marginBottom: "10px",
                }}
              >
                {error}
              </p>
              <p style={{ fontSize: "14px", color: "#666" }}>
                Please refresh the page or contact support.
              </p>
            </div>
          ) : (
            <OurOffering
              title="Our Offerings"
              details="We bring your ideas to life with agile delivery, building MVPs, integrations, and platforms that scale with your business-ensuring rapid progress and lasting impact."
              CardListData={offerList}
              pageName="build"
            />
          )}
        </div>
      </div>
      <div className="mt-70 common-o-bg">
        <CtaCardSection
          className=""
          title={
            <>
              <span className="animationTitle">Ready to </span>
              partner with us?
            </>
          }
          imageUrl={CTAIMAGE1}
          imgClassName="custom-cta-img custom-cta-darken"
        />
      </div>
      <div className="mt-50">
        <FullStackExpertise
          parentWarp="services-modal-wrap"
          title="Other Services"
          showButton={false}
          showItems={["Consult", "Audit"]}
          isServiceCard
        />
      </div>
      <div className="mt-30">
        <OurModelSection />
      </div>
      <div className="mt-70">
        <FAQSection faqs={buildFaqs} />
      </div>
      <div className="mt-70">
        {/* <Box BoxData={BoxData} /> */}
        <TwoColumnContactInfo
          TwoColumnContactInfoData={TwoColumnContactInfoData}
        />
      </div>
    </Layout>
  );
}

export default BuildScreen;
